// import React, { useEffect, useCallback } from 'react';
// import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Form, Input, Row, Col, Typography, Select, Radio, Divider } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
// import styled from 'styled-components';

export const CIPart3 = (props: {
  settlementOptionShowAll?: boolean;
  chequeCurrencyOptions?: { value: string; desc?: string; descTC?: string }[];
}) => {
  const { t, i18n } = useTranslation();
  const form = useFormInstance();
  const settlementOptions = Form.useWatch('settlementOptions', form);
  const chequeCurrency = Form.useWatch('chequeCurrency', form);
  const chequeDeliveryOption = Form.useWatch('chequeDeliveryOption', form);

  const baseSettlementOptionsList = [
    { label: t('life.submitClaims.settlementCheque'), value: 'Cheque' },
    { label: t('life.submitClaims.settlementAccumulate'), value: 'Accumulate in Benefit Accumulation Account' },
    { label: t('life.submitClaims.settlementTelegraphic'), value: 'Telegraphic Transfer' },
  ];
  const settlementOptionsList = props.settlementOptionShowAll
    ? baseSettlementOptionsList
    : baseSettlementOptionsList.filter((item) => item.value !== 'Accumulate in Benefit Accumulation Account');

  const chequeCurrencyOptions = props.chequeCurrencyOptions ?? [];
  const isSingleHkd = chequeCurrencyOptions.length === 1 && chequeCurrencyOptions[0]?.value === 'HKD';

  // 仅一种币种且为 HKD 时， chequeCurrency 强制为 HKD 且不可修改
  useEffect(() => {
    if (isSingleHkd) {
      form.setFieldsValue({ chequeCurrency: 'HKD', chequeCurrencyDesc: 'HKD', chequeCurrencyTc: '港元' });
    }
  }, [isSingleHkd, form]);

  const chequeDeliveryOptions = [
    { label: t('life.submitClaims.deliveryByMail'), value: 'By Mail' },
    { label: t('life.submitClaims.deliveryByInsurance'), value: 'Through insurance intermediary' },
  ];

  const handleSettlementChange = (value: string) => {
    if (value !== 'Cheque') {
      form.setFieldsValue({ chequeCurrency: undefined, chequeDeliveryOption: undefined });
    }
  };

  const changeCurrency = (
    value: string,
    option:
      | { value: string; key: string; label?: string; labelTc?: string }
      | { value: string; key: string; label?: string; labelTc?: string }[],
  ) => {
    if (value) {
      const selected = Array.isArray(option) ? option[0] : option;
      form.setFieldsValue({ chequeCurrencyDesc: selected?.label, chequeCurrencyTc: selected?.labelTc });
    }
  };

  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
      <Col xs={24} md={24} style={{ marginBottom: '10px' }}>
        <Typography.Text className="headertext">{t('life.MakeClaim.mandatoryMsg')}</Typography.Text>
      </Col>

      <Col xs={24} md={24}>
        <BoldLabelFormItem
          rules={[
            {
              required: true,
              message: t('common.error.requiredField'),
            },
          ]}
          required
          label={
            <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {t('life.submitClaims.settlementOptions')}*
            </span>
          }
          name="settlementOptions"
          style={{ marginBottom: settlementOptions === 'Telegraphic Transfer' ? '14px' : '24px' }}
        >
          <Select
            popupClassName="slectop"
            placeholder={t('life.submitClaims.selectSettlement')}
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              padding: '4px 0',
            }}
            onChange={handleSettlementChange}
          >
            {settlementOptionsList.map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </BoldLabelFormItem>
        {settlementOptions === 'Telegraphic Transfer' && (
          <div
            style={{
              fontSize: '17px',
              fontFamily: 'Roboto400',
              color: '#6f7072',
              width: '100%',
              marginBottom: '10px',
            }}
          >
            <div>
              <span>{t('life.submitClaims.payeeBearCharges')}</span>
            </div>
          </div>
        )}
      </Col>

      {settlementOptions === 'Cheque' && (
        <>
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              rules={[
                {
                  required: true,
                  message: t('common.error.requiredField'),
                },
              ]}
              required
              label={
                <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                  {t('life.submitClaims.chequeCurrency')}*
                </span>
              }
              name="chequeCurrency"
              style={{ marginBottom: chequeCurrency === 'hkd' ? '14px' : '24px' }}
            >
              <Select
                popupClassName="slectop"
                placeholder={t('life.submitClaims.selectChequeCurrency')}
                disabled={isSingleHkd}
                style={{
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  padding: '4px 0',
                }}
                onChange={changeCurrency}
              >
                {chequeCurrencyOptions.map((item) => {
                  return (
                    <Select.Option key={item.value} value={item.value} label={item.desc} labelTc={item.descTC}>
                      {i18n.language === 'zh' ? item.descTC : item.desc}
                    </Select.Option>
                  );
                })}
              </Select>
            </BoldLabelFormItem>
            {chequeCurrency === 'hkd' && (
              <div
                style={{
                  fontSize: '17px',
                  fontFamily: 'Roboto400',
                  color: '#6f7072',
                  width: '100%',
                  marginBottom: '10px',
                }}
              >
                <div>
                  <span>{t('life.submitClaims.HKDdesscription')}</span>
                </div>
              </div>
            )}
          </Col>

          <Col xs={24} md={24}>
            <BoldLabelFormItem
              rules={[
                {
                  required: true,
                  message: t('common.error.requiredField'),
                },
              ]}
              required
              label={
                <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                  {t('life.submitClaims.chequeDeliveryOption')}*
                </span>
              }
              name="chequeDeliveryOption"
              style={{ marginBottom: chequeDeliveryOption === 'By Mail' ? '14px' : '24px' }}
            >
              <Select
                popupClassName="slectop"
                placeholder={t('life.submitClaims.selectChequeDelivery')}
                style={{
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  padding: '4px 0',
                }}
              >
                {chequeDeliveryOptions.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </BoldLabelFormItem>
            {chequeDeliveryOption === 'By Mail' && (
              <div
                style={{
                  fontSize: '17px',
                  fontFamily: 'Roboto400',
                  color: '#6f7072',
                  width: '100%',
                  marginBottom: '10px',
                }}
              >
                <div>
                  <span>{t('life.submitClaims.policyownerCorrespondence')}</span>
                </div>
              </div>
            )}
          </Col>
        </>
      )}
      <Col xs={24} md={24}>
        <div style={{ fontSize: '22px', fontFamily: 'Roboto400', color: '#20252b' }}>
          <span>{t('life.MakeRequest.contact.termstittle')}</span>
        </div>
        <div
          style={{
            fontSize: '15px',
            fontFamily: 'Roboto400',
            paddingTop: '15px',
            color: '#20252b',
            fontWeight: '500',
            paddingBottom: '15px',
            borderBottom: '1px solid #CCCCCC',
          }}
        >
          <span>{t('life.MakeRequest.contact.terms')}</span>
        </div>
      </Col>
      <Col xs={24} md={24} style={{ marginTop: '-9px' }}>
        <BoldLabelFormItem
          label={
            <span
              style={{
                color: '#6f7072',
                fontWeight: 'normal',
                fontSize: '15px',
                fontFamily: 'Roboto400',
              }}
              dangerouslySetInnerHTML={{
                __html: t('life.beneficiaries.PEP').replace(/<p>/g, '<p style="margin:0;padding:0;">'),
              }}
            ></span>
          }
          name="isDeclaration"
          rules={[{ required: true, message: t('common.error.requiredField') }]}
          style={{ marginBottom: 0 }}
        >
          <Radio.Group>
            <Radio key={'pep_Y'} value={'Yes'} style={{ marginRight: '130px', color: '#6F7072' }}>
              {t('common.yes')}
            </Radio>
            <Radio key={'pep_N'} value={'No'} style={{ color: '#6F7072' }}>
              {t('common.no')}
            </Radio>
          </Radio.Group>
        </BoldLabelFormItem>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => prevValues.isDeclaration !== currentValues.isDeclaration}
        >
          {({ getFieldValue }) =>
            getFieldValue('isDeclaration') === 'Yes' ? (
              <>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    rules={[{ required: true, message: t('common.error.requiredField') }]}
                    label={
                      <div>
                        <p
                          style={{
                            fontWeight: 'normal',
                            fontSize: '17px',
                            fontFamily: 'Roboto500',
                            marginBottom: 0,
                            color: '#752127',
                          }}
                        >
                          {t('life.beneficiaries.pepName')}*
                        </p>
                      </div>
                    }
                    name="pepName"
                  >
                    <Input
                      size="middle"
                      placeholder={t('life.beneficiaries.enter', {
                        content: t('life.beneficiaries.pepName'),
                      })}
                      style={{
                        color: '#20252B',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        padding: '4px 10px',
                      }}
                    />
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    rules={[{ required: true, message: t('common.error.requiredField') }]}
                    label={
                      <div>
                        <p
                          style={{
                            fontWeight: 'normal',
                            fontSize: '17px',
                            fontFamily: 'Roboto500',
                            marginBottom: 0,
                            color: '#752127',
                          }}
                        >
                          {t('life.beneficiaries.pepPosition')}*
                        </p>
                      </div>
                    }
                    name="pepPosition"
                  >
                    <Input
                      size="middle"
                      placeholder={t('life.beneficiaries.enter', {
                        content: t('life.beneficiaries.pepPosition'),
                      })}
                      style={{
                        color: '#20252B',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        padding: '4px 10px',
                      }}
                    />
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24}>
                  <div style={{ fontSize: '22px', fontFamily: 'Roboto400', color: '#6f7072' }}>
                    <span>{t('life.beneficiaries.party')}</span>
                  </div>
                </Col>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    rules={[{ required: true, message: t('common.error.requiredField') }]}
                    label={
                      <div>
                        <p
                          style={{
                            fontWeight: 'normal',
                            fontSize: '17px',
                            fontFamily: 'Roboto500',
                            marginBottom: 0,
                            color: '#752127',
                          }}
                        >
                          {t('life.beneficiaries.pepRelevant')}*
                        </p>
                      </div>
                    }
                    name="pepRelevantPartyName"
                  >
                    <Input
                      size="middle"
                      placeholder={t('life.beneficiaries.enter', {
                        content: t('life.beneficiaries.pepRelevant'),
                      })}
                      style={{
                        color: '#20252B',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        padding: '4px 10px',
                      }}
                    />
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    rules={[{ required: true, message: t('common.error.requiredField') }]}
                    label={
                      <div>
                        <p
                          style={{
                            fontWeight: 'normal',
                            fontSize: '17px',
                            fontFamily: 'Roboto500',
                            marginBottom: 0,
                            color: '#752127',
                          }}
                        >
                          {t('life.beneficiaries.pepRelationship')}*
                        </p>
                      </div>
                    }
                    name="pepRelationship"
                  >
                    <Input
                      size="middle"
                      placeholder={t('life.beneficiaries.enter', {
                        content: t('life.beneficiaries.pepRelationship'),
                      })}
                      style={{
                        color: '#20252B',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        padding: '4px 10px',
                      }}
                    />
                  </BoldLabelFormItem>
                </Col>
              </>
            ) : null
          }
        </Form.Item>
      </Col>
      <Col xs={24} md={24} style={{ marginTop: '-9px' }}>
        <Divider style={{ margin: 0, borderColor: '#cccccc' }} />
        <div
          style={{
            fontSize: '15px',
            fontFamily: 'Roboto400',
            color: '#6f7072',
            paddingTop: '15px',
          }}
        >
          <sup>#1</sup>
          <span>{t('life.beneficiaries.pepDesc1')}</span>
        </div>
        <div
          style={{
            fontSize: '15px',
            fontFamily: 'Roboto400',
            color: '#6f7072',
            paddingBottom: '15px',
          }}
        >
          <sup>#2</sup>
          <span>{t('life.beneficiaries.pepDesc2')}</span>
        </div>
      </Col>
    </Row>
  );
};
